class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onSummaryClick = this.onSummaryClick.bind(this);
    const summary = this.querySelector('summary');
    if (summary) summary.addEventListener('click', this.onSummaryClick);
  }

  /* Desktop + mobile: open only on click (no hover auto-open) */
  onSummaryClick(event) {
    if (event.detail === 0) return; // ignore synthetic clicks from keyboard activation quirks when needed
    // Close sibling menus after native toggle settles
    const details = this.mainDetailsToggle;
    setTimeout(() => {
      document.querySelectorAll('header-menu details[open]').forEach((el) => {
        if (el !== details) {
          el.removeAttribute('open');
          const otherSummary = el.querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', false);
        }
      });
      if (details.open) {
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', true);
        if (this.header) this.header.preventHide = true;
      } else {
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', false);
        if (this.header) this.header.preventHide = false;
      }
    }, 0);
  }

  open() {
    document.querySelectorAll('header-menu details[open]').forEach((el) => {
      if (el !== this.mainDetailsToggle) {
        el.removeAttribute('open');
        const otherSummary = el.querySelector('summary');
        if (otherSummary) otherSummary.setAttribute('aria-expanded', false);
      }
    });
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', true);
    if (this.header) this.header.preventHide = true;
  }

  close() {
    super.close();
    if (this.header) this.header.preventHide = false;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
